import React, { memo, useEffect, useMemo, useState, } from 'react';
import { View } from 'react-native';
const RenderWidgetGroup = ({ activeWidgetId, widgetMap, renderItem, extraProps = {}, }) => {
    const [_child, setChild] = useState(widgetMap[activeWidgetId]);
    const child = () => useMemo(() => (React.createElement(React.Fragment, null, renderItem &&
        widgetMap &&
        widgetMap[activeWidgetId].map(renderItem))), [widgetMap, activeWidgetId, extraProps]);
    useEffect(() => {
        setChild(widgetMap[activeWidgetId]);
    }, [activeWidgetId]);
    return (React.createElement(View, { style: {
            flex: 1,
            height: '100%',
        } }, child()));
};
export default memo(RenderWidgetGroup);
export { RenderWidgetGroup };
